import React, { useEffect, useState } from 'react'
import { TextArea, Input } from '@arnsbogroup/react-voicearchive'

const HistoricPrices = ( { supplier } ) => {

    const [state, setState] = useState(null)
    const [priceIndexExplanation, setPriceIndexExplanation] = useState(null)

    useEffect(() => {
        fetchPricesData()
        getValueInCurrency()
    }, [])

    const fetchPricesData = () => {
        fetch(`/supplierdisplay/prices.json?supplierId=${supplier.uid}`)
            .then((response) => response.json())
            .then((response) => {
                if (!response.success) {
                    toastr.error(response.errors.join(', '))
                } else {
                    setState(response.data)
                }
            })
            .catch((error) => toastr.error(error))
    }
    
    const getValueInCurrency = () => {
        const currencyId = supplier?.currency?.uid || 2
        const name = supplier?.currency?.name || ''
        const indexOne = supplier.priceindex ? supplier.priceindex : 0
        const indexTwo = (3.92 * supplier.priceindex).toFixed(2)
        let priceOne = 0
        let priceTwo = 0
        fetch(`/orderjobdisplay/getValueInCurrency.json?value=${indexOne}&sourceCurrencyId=2&targetCurrencyId=${currencyId}`)
            .then((response) => response.json())
            .then((response) => {
                priceOne = response
            })
            .catch((error) => toastr.error(error))
            .finally(() => {
                fetch(`/orderjobdisplay/getValueInCurrency.json?value=${indexTwo}&sourceCurrencyId=2&targetCurrencyId=${currencyId}`)
                    .then((response) => response.json())
                    .then((response) => {
                        priceTwo = response
                    })
                    .catch((error) => toastr.error(error))
                    .finally(() => {
                        setPriceIndexExplanation(`This means that your price for 600 words would be ${priceOne} ${name} and your price for 3600 words would be ${priceTwo} ${name}`)
                    })
            })
    }

    const BroadcastBody = (value) => (
        <div key={value.pricingId} className='p-2'>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <p className='font-medium my-2'>{value.value.type.name}</p>
                    <p className='my-2'>{value.value.type.desc}</p>
                </div>
                <div>
                    <Input
                        size="sm"
                        value={value.value.value}
                        disabled
                    />
                </div>
            </div>
        </div>
    )

    if (!state) {
        return null
    }

    return (
        <div className='w-full px-20 pt-2'>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <p className='font-medium my-2 border-b text-xl'>Internal Price Comment</p>
                    <TextArea
                        rows={8}
                        value={supplier.priceCommentInternal}
                        disabled
                    />
                </div>
                <div>
                    <p className='font-medium my-2 border-b text-xl'>External Price Comment</p>
                    <TextArea
                        rows={8}
                        value={supplier.priceCommentExternal}
                        disabled
                    />
                </div>
            </div>
            <p className='font-medium my-2 border-b text-xl'>Currency and Price Index</p>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <Input
                        label="Currency"
                        value={supplier.currency.iso || ''}
                        disabled
                    />
                </div>
                <div>
                    <Input
                        label="Index"
                        value={`${supplier.priceindex}%`}
                        disabled
                    />
                    <p>{priceIndexExplanation ? priceIndexExplanation : 'Price Index Explanation'}</p>
                </div>
            </div>
            <p className='font-medium my-2 border-b text-xl'>Technical Capabilities</p>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <p className='font-medium my-2'>Timing</p>
                    <p>Timing on paragraph level according to time codes in script</p>
                </div>
                <div>
                    <p className='font-medium my-2'>Synchronization</p>
                    <p>Synchronization on sentence level according to time codes in script and a client's video (you will receive a downloadable version of the video)</p>
                </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <Input
                        label="Price Index"
                        value={`${state.editing.timing.value}`}
                        disabled
                    />
                </div>
                <div>
                    <Input
                        label="Price Index"
                        value={`${state.editing.synchronisation.value}%`}
                        disabled
                    />
                </div>
            </div>
            <p className='font-medium my-2 border-b text-xl'>Non-broadcast</p>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <p>
                        If you are in doubt of which price index matches your 600 to 3600 words’ rates, please below find the non-broadcast rates you previously have entered.<br />
                        Please list your rates for the below services.<br />
                        Uncompleted fields will be deemed as non-relevant to you and you will not be offered assignments in these categories.<br />
                        Feel free to adjust your rates any time.
                    </p>
                </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    {state.supplierValues['non-Broadcast'].map((value) => (
                        <BroadcastBody value={value} />
                    ))}
                </div>
            </div>
            
            <p className='font-medium my-2 border-b text-xl'>Broadcast National</p>
            <p>Please base your rates on 1 year buy out in your native country.</p>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    {state.supplierValues['broadcastNational'].map((value) => (
                        <BroadcastBody value={value} />
                    ))}
                </div>
            </div>
            <p className='font-medium my-2 border-b text-xl'>Broadcast Regional</p>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    {state.supplierValues['broadcastRegional'].map((value) => (
                        <BroadcastBody value={value} />
                    ))}
                </div>
            </div>
            <p className='font-medium my-2 border-b text-xl'>Broadcast Local</p>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    {state.supplierValues['broadcastLocal'].map((value) => (
                        <BroadcastBody value={value} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default HistoricPrices
